/* eslint-disable */

import React, { useState } from 'react';
import DailyBulletinGrid from 'components/molecules/DailyBulletinGrid';
import { IData, IRow } from 'components/molecules/DailyBulletinGrid/types';
import { TableColumnWidthInfo } from '@devexpress/dx-react-grid';

import {
  postCorrectivesGrid,
  postDailyBulletinGrid,
  postExportDailyBulletinGrid,
  postExportPdfDailyBulletinGrid,
} from 'services/daily-bulletin';
import { useQuery } from 'react-query';
import qs from 'querystring';
import { useSelectFilter } from 'hooks/planning/useFilter';
import { generatedCompositeId, openInNewTab } from 'helpers';
import { CORRECTIVES } from 'constants/grid/names';
import { useDispatchGrid, useGridData } from 'hooks/grid/useDailyBulletinGrid';
import { PLANNING_GRID_ID } from 'constants/grid/grid';
import {
  getGridConfiguration,
  postGridConfiguration,
} from 'services/grid-configuration';
import { IGridConfig } from 'components/molecules/PlanningGrid/types';
import { columns } from './data';

const TAKE = 10;
const MAX_ROWS = 100000;

const mapRows = (result: IRow[]) => {
  return result.map(row => {
        const dateStart = row.realStart
      ? row.realStart
      : row.replanStart
      ? row.replanStart
      : row.planStart
      ? row.planStart
      : '';

    const dateCompletion = row.realCompletion
      ? row.realCompletion
      : row.replanCompletion
      ? row.replanCompletion
      : row.planCompletion
      ? row.planCompletion
      : '';

    const datePlanCompletion =
      dateCompletion >= dateStart ? dateCompletion : '';

    return {
      activityPlanId: row.activityPlanId,
      activityRealId: row.activityRealId,
      activityDiverseId: row.activityDiverseId,
      bulletinStatus: row.bulletinStatus,
      status: row.status,
      activity: row.activity,
      maintenanceType: row.maintenanceType ?? 'Diversas',
      equipment: row.equipment ?? row.area,
      observationField: row.observationField,
      planStart: dateStart,
      novaProp:
        row.activityDiverseId !== null
          ? 'DIVERSAS'
          : row.executor === 'GAMESA' ||
            row.executor === 'GE' ||
            row.executor === 'VESTAS' || 
            row.executor === 'ACCIONA'
          ? 'WTG'
          : 'BoP',
      planCompletion: datePlanCompletion,
      executor: row.executor,
      id: generatedCompositeId(row),
      outage: row.outage,
      utilization: row.utilization,
      realStart: row.realStart,
      pauseStartBr: row.pauseStart,
    };
    // }
  });
};

const DailyBulletinGridContainer = ({
  setUpdatedAt,
}: {
  setUpdatedAt: React.Dispatch<React.SetStateAction<Date | null>>;
}) => {
  const [open, setOpen] = React.useState<boolean>(true);
  const gridDataInput = useGridData(CORRECTIVES);
  const [totalRowsInput, setTotalRowsInput] = React.useState(MAX_ROWS);

  const [
    installationFilterOptionsContext,
    dateFilterOptionsContext,
    supplierFilterOptionsContext,
    // activityStatusFilterOptionsContext,
  ] = [
    useSelectFilter('installation'),
    useSelectFilter('date'),
    useSelectFilter('supplier'),
    // useSelectFilter('activity-status'),
  ];
  const allFilterContexts = React.useMemo(
    () => [
      installationFilterOptionsContext,
      dateFilterOptionsContext,
      supplierFilterOptionsContext,
      // activityStatusFilterOptionsContext,
    ],
    [
      installationFilterOptionsContext,
      dateFilterOptionsContext,
      supplierFilterOptionsContext,
      // activityStatusFilterOptionsContext,
    ],
  );

  const [totalRows, setTotalRows] = React.useState(MAX_ROWS);
  const [currentPage, setCurrentPage] = React.useState<number>(0);
  const [pageSize, setPageSize] = React.useState<number>(TAKE);
  const pageSizes = React.useMemo(() => [10, 20, 30, 40, 50, 100], []);

  const correctives = useGridData(CORRECTIVES);
  const changeGrid = useDispatchGrid(CORRECTIVES);

  const [exportingGridData, setExportingGridData] =
    React.useState<boolean>(false);

  const [exportingPdfGridData, setExportingPdfGridData] =
    React.useState<boolean>(false);
  // INÍCIO ESTADO DAS CONFIGURAÇÕES DAS GRID

  const [order, setOrder] = React.useState<string[]>(() => {
    return columns.map(column => column.name);
  });

  const [widths, setWidths] = React.useState<TableColumnWidthInfo[]>(() => {
    return columns.map(column => ({
      columnName: column.name,
      width: column.width,
    }));
  });

  const [dataGrid, setDataGrid] = React.useState(() => columns);
  // FIM ESTADO DAS CONFIGURAÇÕES DAS GRID
  // INÍCIO ESTADO DAS LINHAS DO GRID
  const [gridRows, setGridRows] = React.useState<IRow[]>([]);
  // FIM ESTADO DAS LINHAS DO GRID
  // const dataGrid = React.useMemo<IData[]>(() => columns, []);
  // const [gridRows, setGridRows] = React.useState<IRow[]>([]);
  // const dataGrid = React.useMemo<IData[]>(() => columns, []);

  // INÍCIO ESTADO DE ORDENACAO DO GRID
  const gridOrder = React.useMemo(
    () =>
      dataGrid
        .filter(column => column.direction)
        .map(column => ({
          columnName: column.name,
          order: column.direction?.toLocaleUpperCase(),
        })),
    [dataGrid],
  );
  // FIM ESTADO DE ORDENACAO DO GRID

  const installationIds = React.useMemo(
    () => installationFilterOptionsContext.map(item => Number(item?.value)),
    [installationFilterOptionsContext],
  );

  const supplierExecutors = React.useMemo(
    () => supplierFilterOptionsContext.map(item => Number(item?.value)),
    [supplierFilterOptionsContext],
  );

  // const activityStatusIds = React.useMemo(
  //   () => activityStatusFilterOptionsContext.map(item => String(item?.value)),
  //   [activityStatusFilterOptionsContext],
  // );

  const dateSelected = React.useMemo(
    () => dateFilterOptionsContext[0].value,
    [dateFilterOptionsContext],
  );

  // AO ALTERAR OS FILTROS, DEVERÁ RETORNAR PARA PÁGINA INICIAL
  React.useEffect(() => {
    setCurrentPage(0);
  }, [allFilterContexts, pageSize]);

  const enableQueries = React.useMemo(() => open, [open]);

  const queryDailyBulletinGrid = useQuery({
    queryKey: [
      'DailyBulletinGridDataContext',
      [pageSize, currentPage, gridOrder, ...allFilterContexts],
    ],
    queryFn: async () => {
      const qsparams = qs.stringify({
        page: currentPage + 1,
        take: pageSize,
      });

      const params = {
        installationIds,
        supplierExecutors,
        date: dateSelected,
        order: gridOrder,
        flag: true,
      };
      const { data } = await postDailyBulletinGrid(qsparams, params);
      return data;
    },
    select: data => {
      const rows: IRow[] = mapRows(data.mappedResult);
      return {
        count: data.count,
        rows,
      };
    },
    onSuccess: ({ count, rows }: { rows: IRow[]; count: number }) => {
      setGridRows(rows);
      setTotalRows(count);
    },

    // enabled: true,
    // cacheTime: 0,
    enabled: enableQueries,
  });

  const queryCorrectivesGrid = useQuery({
    queryKey: [
      'CorrectivesQueryContext',
      [pageSize, currentPage, gridDataInput.lastUpdate, ...allFilterContexts],
    ],
    queryFn: async () => {
      const qsparams = qs.stringify({
        page: currentPage + 1,
        take: pageSize,
      });

      const params = {
        installationIds,
        date: dateSelected,
      };
      const { data } = await postCorrectivesGrid(qsparams, params);
      return data;
    },
    select: data => {
      const rows: IRow[] = mapRows(data.result);
      return {
        rows,
        count: data.count,
      };
    },
    onSuccess: ({ count, rows }: { rows: IRow[]; count: number }) => {
      // setGridRows(rows);
      setTotalRowsInput(count);

      changeGrid({
        ...gridDataInput,
        numberOfCorrectives: count,
      });
    },
    enabled: true,
    cacheTime: 0,
  });

  const queryPlanningGridConfigurations = useQuery({
    queryKey: ['PlanningGridConfigurationContext'],
    queryFn: async () => {
      const qsparams = qs.stringify({ gridId: PLANNING_GRID_ID });
      const { data } = await getGridConfiguration(qsparams);
      return data;
    },
    onSuccess: data => {
      const { configuration } = data;
      const checkIsSameColumns = (
        currentCols: string[],
        newCols: string[],
      ): boolean => {
        // que tem o mesmo tamanho
        const hasSameLength = currentCols.length === newCols.length;
        // que tem os mesmos items
        const hasSameItens = currentCols.every(colName =>
          newCols.includes(colName),
        );
        return hasSameLength && hasSameItens;
      };

      // antes de alterar a ordem com os dados do servidor
      // tenho que me certificar de que os dados são compatíveis

      if (configuration?.order) {
        setOrder(currentOrder => {
          const isSameColumns = checkIsSameColumns(
            currentOrder,
            configuration?.order,
          );

          // caso contrário mantém a configuração anterior
          return isSameColumns ? configuration?.order : currentOrder;
        });
      }
      if (configuration?.columns) {
        setWidths(currentWidths => {
          const currentCols = currentWidths.map(col => col.columnName);
          const newCols = configuration?.columns.map(col => col.columnName);

          const isSameColumns = checkIsSameColumns(currentCols, newCols);

          // caso contrário mantém a configuração anterior
          return isSameColumns ? configuration?.columns : currentWidths;
        });
      }
    },
    enabled: enableQueries,
  });

  const onSortingChange = React.useCallback(sortedList => {
    setDataGrid(oldDataGrid =>
      oldDataGrid.map(item => {
        const findedItem = sortedList.find(
          sortItem => sortItem.columnName === item.name,
        );
        if (findedItem) {
          return {
            ...item,
            direction: findedItem.direction,
          };
        }
        const newItem = { ...item };
        delete newItem.direction;
        return newItem;
      }),
    );
  }, []);

  const getRowId = React.useCallback((row: IRow) => String(row.id), []);
  const getRowById = React.useCallback(
    id => {
      const strId = `${id}`;
      return gridRows.find(row => `${row?.id}` === strId);
    },
    [gridRows],
  );

  const isRowEnabled = React.useCallback(
    (row: IRow) => !(row?.blockedForMobile && row?.blockedForMobile === 'S'),
    [],
  );

  const onSaveGridConfiguration = React.useCallback(
    async (params: IGridConfig) => {
      try {
        await postGridConfiguration({
          gridId: PLANNING_GRID_ID,
          configuration: params,
        });
        // mensagem de sucesso?
      } catch (error) {
        // mensagem de falha?
      }
    },
    [],
  );

  const refetch = React.useCallback(() => {
    setUpdatedAt(new Date());
    queryDailyBulletinGrid.refetch();

    changeGrid({
      ...correctives,
      lastUpdate: new Date(),
    });
  }, [changeGrid, correctives, queryDailyBulletinGrid, setUpdatedAt]);

  const exportGridData = React.useCallback(() => {
    setExportingGridData(true);

    const qsparams = qs.stringify({
      page: currentPage + 1,
      take: pageSize,
    });

    const params = {
      installationIds,
      date: dateSelected,
      order: gridOrder,
    };
    // TODO: seria interessante alterar o contrato no backend
    // para retornar as mensagens para o usuário
    postExportDailyBulletinGrid(qsparams, params)
      .then(({ url }) => {
        openInNewTab(url);
      })
      .finally(() => setExportingGridData(false));
  }, [currentPage, dateSelected, gridOrder, installationIds, pageSize]);

  const exportPdfGridData = React.useCallback(() => {
    setExportingPdfGridData(true);
    const qsparams = qs.stringify({
      page: currentPage + 1,
      take: pageSize,
    });

    const params = {
      installationIds,
      date: dateSelected,
      order: gridOrder,
      supplierExecutors: [],
      areaType: '',
      type: '',
      email: true,
    };
    // TODO: seria interessante alterar o contrato no backend
    // para retornar as mensagens para o usuário
    postExportPdfDailyBulletinGrid(qsparams, params)
      .then(({ data }) => {
        openInNewTab(data);
      })
      .finally(() => setExportingPdfGridData(false));
  }, [currentPage, dateSelected, gridOrder, installationIds, pageSize]);

  return (
    <DailyBulletinGrid
      columns={dataGrid as IData[]}
      orderOfColumns={order}
      widthOfColumns={widths}
      rows={gridRows}
      loading={
        queryDailyBulletinGrid?.isLoading ||
        queryPlanningGridConfigurations?.isLoading ||
        queryDailyBulletinGrid?.isFetching ||
        exportingGridData ||
        exportingPdfGridData
      }
      tooltipMaxStrLength={50} 
      onSaveGridConfiguration={onSaveGridConfiguration}
      statusCells={['bulletinStatus']}
      statusCells2={['status']}
      tooltipCells={['equipment', 'activity', 'observationField']}
      // yesOrNotCells={['outage', 'utilization']}
      dayMonthTimeCells={['planStart', 'planCompletion']}
      isRowEnabled={isRowEnabled}
      pageSize={pageSize}
      pageSizes={pageSizes}
      totalCount={totalRows}
      currentPage={currentPage}
      onCurrentPageChange={setCurrentPage}
      onPageSizeChange={setPageSize}
      expandAccordion={open}
      setExpandAccordion={setOpen}
      getRowId={getRowId}
      getRowById={getRowById}
      refetch={refetch}
      onExport={exportGridData}
      onPdf={exportPdfGridData}
      onSortingChange={onSortingChange}
    />
  );
};

export default DailyBulletinGridContainer;
